import { CaseStudy } from '../../types';
import { GO_DUTCH_HERO } from '../../assets/images';

export const goDutch: CaseStudy = {
  id: '1',
  title: 'Go Dutch',
  category: 'Seamless Bill Splitting',
  imageUrl: GO_DUTCH_HERO,
  description: 'Go Dutch is designed for the moments that matter. No more awkward math at the end of a great meal. By combining a beautiful, minimalist interface with powerful OCR technology, friends can scan a bill, assign items, and settle up in seconds—all while staying present in the conversation.',
  screenshots: [
    'https://images.unsplash.com/photo-1556742044-3c52d6e88c62?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=800&auto=format&fit=crop'
  ]
};